import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './styles.css';

const HearAtConversion = () => {
  const handleScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with id ${sectionId} not found`);
    }
  };
  return (
    <div className='hear-container'>
      <div>
        <h1
          className='framer-text'
          style={{
            textAlign: 'center',
            // fontSize: '3rem',
            color: 'white',
            fontWeight: 'var(--framer-font-weight)',
          }}
        >
          Here at Future Ethics Media, We Focus on<br/>
           Returns Through Organic Growth.
        </h1>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          outline: 'none',
          flexWrap: 'wrap',
          transform: 'none',
          position: 'relative',
        }}
      >
        <p
          style={{
            textAlign: 'center',
            fontWeight: 'var(--framer-font-weight)',
            color: '#9c9c9c',
            fontSize: '1.2rem',
            lineHeight: '2rem',
            fontFamily: 'var(--framer-font-family)',
          }}
        >
          We're dedicated to elevating your brand with strategic organic marketing.<br/>
          Break free from traditional paid strategies and take your brand to the<br/>
          next level—achieve sustainable success and genuine customer engagement.
        </p>
      </div>
      <div>
        <motion.button
          style={{
            padding: '1rem',
            backgroundColor: '#fd4635',
            color: 'white',
            width: 'fit-content',
            border: 'none',
            borderRadius: '0.7rem',
            cursor: 'pointer',
            fontSize: 'var(--framer-font-size)',
            fontFamily: 'var(--framer-font-family)',
            fontWeight: 'var(--framer-font-weight)',
            letterSpacing: 'var(--framer-letter-spacing)',
            textAlign: 'center',
          }}
          whileHover={{
            boxShadow:
              '0 0 5px #fd4635, 0 0 10px #fd4635, 0 0 15px white, 0 0 20px black',
            transition: { duration: 0.5 },
          }}
          whileTap={{
            scale: 0.9,
            transition: { duration: 0.2 },
          }}
          onClick={() => handleScrollTo('book-call')}
        >
          <Link
            style={{ textDecoration: 'none', color: 'white' }}
            
          >
            Book a 15-min Call
          </Link>
        </motion.button>
      </div>

      {/* Inline Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            .framer-text {
              font-size: 3rem;
            }
          }

          @media (max-width: 768px) {
            .framer-text {
              font-size: 2rem;
            }
            p {
              // font-size: 1.4rem;
              line-height: 2rem;
            }
            button {
              padding: 0.8rem;
              font-size: 1rem;
            }
          }

          @media (max-width: 480px) {
            p {
              font-size: 1.2rem;
              line-height: 1.8rem;
            }
            button {
              padding: 0.7rem;
              font-size: 0.9rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default HearAtConversion;
